import { render, staticRenderFns } from "./addNewUserGuide.vue?vue&type=template&id=5533d9f5&scoped=true"
import script from "./addNewUserGuide.vue?vue&type=script&lang=js"
export * from "./addNewUserGuide.vue?vue&type=script&lang=js"
import style0 from "./addNewUserGuide.vue?vue&type=style&index=0&id=5533d9f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533d9f5",
  null
  
)

export default component.exports